import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const cateringInquiryFormDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.cateringInquiry,
  componentType: LAYOUT_COMPONENT_TYPE.cateringInquiryForm,
  registryBlockKey: REGISTRY_BLOCK.presentation.cateringInquiryForm,
  displayOrder: 5,
  content: {
    heading: loc3('Catering anfragen', 'Ask about catering', 'Hỏi về catering'),
    supporting: loc3(
      'Büros, Events und private Feiern ab 20 Portionen.',
      'Offices, events and private parties from 20 portions.',
      'Văn phòng, sự kiện và tiệc riêng từ 20 phần.',
    ),
    ctaLabel: loc3('Anfrage senden', 'Send inquiry', 'Gửi yêu cầu'),
    note: loc3(
      'Mindestens 5 Tage Vorlauf.',
      'At least 5 days notice.',
      'Ít nhất 5 ngày trước.',
    ),
  },
  media: {},
};
